export default "__VITE_ASSET__DihD2vXt__"